module.exports = __webpack_public_path__ + "static/images/containers/ShopView/images/small/package_l.be5ad4e9.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ShopView/images/small/package_l.png
// module id = 993
// module chunks = 16